var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import * as QrReader from "react-qr-reader";
import { useAdmin2Client } from "./context";
import { useLazyQuery } from "react-apollo";
import admin2Gql from "graphql-tag";
import { ActivationRequestStatus, } from "./admin-gql-2";
import { Spinner } from "./Spinner";
import i18next from "i18next";
export var ActivationRequestQrReader = function (props) {
    var _a = React.useState({
        manualActivationRequestId: "",
    }), state = _a[0], setState = _a[1];
    var client = useAdmin2Client();
    var _b = useLazyQuery(admin2Gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query ValidateActivationRequest($id: String!) {\n      activationRequest(id: $id) {\n        id\n        status\n      }\n    }\n  "], ["\n    query ValidateActivationRequest($id: String!) {\n      activationRequest(id: $id) {\n        id\n        status\n      }\n    }\n  "]))), {
        client: client,
        fetchPolicy: "network-only",
        onCompleted: function (data) {
            var _a;
            if (((_a = data.activationRequest) === null || _a === void 0 ? void 0 : _a.status) === ActivationRequestStatus.WAITING) {
                props.onActivationRequestId(data.activationRequest.id);
            }
            else {
                setState(function (p) { return (__assign(__assign({}, p), { error: i18next.t("cc.action.request.qr.reader.invalidQRCodeOrActivationId") })); });
            }
        },
    }), validate = _b[0], validationQuery = _b[1];
    var handleQrError = function () {
        setState(function (p) { return (__assign(__assign({}, p), { error: i18next.t("cc.action.request.qr.reader.failedToScanQRCode") })); });
    };
    var handleQrScan = function (data) {
        if (data && !validationQuery.loading) {
            try {
                var qrData = JSON.parse(data);
                if (!qrData.i || typeof qrData.t !== "number") {
                    setState(function (p) { return (__assign(__assign({}, p), { error: i18next.t("cc.action.request.qr.reader.invalidQRCode") })); });
                }
                else if (qrData.t * 1000 < Date.now()) {
                    setState(function (p) { return (__assign(__assign({}, p), { error: i18next.t("cc.action.request.qr.reader.qrCodeIsNoLongerValid") })); });
                }
                else {
                    setState(function (p) { return (__assign(__assign({}, p), { error: undefined })); });
                    validate({ variables: { id: qrData.i } });
                }
            }
            catch (error) {
                setState(function (p) { return (__assign(__assign({}, p), { error: i18next.t("cc.action.request.qr.reader.invalidQRCode") })); });
            }
        }
    };
    var handleManualInputChange = function (ev) {
        var newManualActivationRequestId = ev.currentTarget.value;
        var trimmedManualActivationId = newManualActivationRequestId
            .trim()
            .replace(/ /g, "");
        if (trimmedManualActivationId.length <= 9) {
            setState({
                manualActivationRequestId: newManualActivationRequestId,
            });
            if (trimmedManualActivationId.length > 8) {
                validate({
                    variables: { id: trimmedManualActivationId },
                });
            }
        }
    };
    if (validationQuery.error) {
        return (React.createElement("div", { className: "alert alert-danger" }, i18next.t("cc.action.request.qr.reader.somethingWrongTryAgain")));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: {
                border: "1px solid black",
                width: "100%",
                maxWidth: "50vh",
                margin: "auto",
                position: "relative",
            } },
            React.createElement(QrReader, { onScan: handleQrScan, onError: handleQrError, facingMode: "environment", showViewFinder: false }),
            React.createElement("div", { style: {
                    position: "absolute",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    backgroundColor: validationQuery.loading
                        ? "rgba(255, 255, 255, 0.7)"
                        : "transparent",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "background 200ms",
                } }, validationQuery.loading ? React.createElement(Spinner, null) : null)),
        React.createElement("p", { className: "mt-content" },
            i18next.t("cc.action.request.qr.reader.enterActivationCode"),
            React.createElement("input", { className: "form-control", type: "text", placeholder: "XXX XXX XXX", disabled: props.disabled, value: state.manualActivationRequestId, onChange: handleManualInputChange })),
        state.error ? (React.createElement("div", { className: "alert alert-danger" }, state.error)) : null));
};
var templateObject_1;
//# sourceMappingURL=ActivationRequestQrReader.js.map